import { bigNumberify } from '@sparkdotfi/common-universal'
import { multicall } from 'wagmi/actions'

import { PotSavingsConverter } from './PotSavingsConverter'
import { SavingsConverterQueryOptions, SavingsConverterQueryParams } from './types'
import { stusdsConfig } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'

export function stusdsConverterQueryOptions({
  wagmiConfig,
  timestamp,
  chainId,
}: SavingsConverterQueryParams): SavingsConverterQueryOptions {
  return {
    queryKey: ['stusds-converter', { chainId }],
    queryFn: async () => {
      const stusdsAddress = getContractAddress(stusdsConfig.address, chainId)
      const stusdsAbi = stusdsConfig.abi

      const [str, rho, chi] = await multicall(wagmiConfig, {
        allowFailure: false,
        chainId,
        contracts: [
          {
            address: stusdsAddress,
            functionName: 'str',
            args: [],
            abi: stusdsAbi,
          },
          {
            address: stusdsAddress,
            functionName: 'rho',
            args: [],
            abi: stusdsAbi,
          },
          {
            address: stusdsAddress,
            functionName: 'chi',
            args: [],
            abi: stusdsAbi,
          },
        ],
      })

      return {
        str,
        rho,
        chi,
      }
    },
    select: ({ str, rho, chi }) => {
      return new PotSavingsConverter({
        potParams: {
          sr: bigNumberify(str),
          rho: bigNumberify(rho),
          chi: bigNumberify(chi),
        },
        currentTimestamp: timestamp,
      })
    },
  }
}
